import { Breadcrumb } from 'antd'
import { Link } from 'react-router-dom'
import { Device } from '../Device'

import './styles.scss'
export interface BreadcrumbCustomProps {
  routes: Array<{
    title: string
    path: string
  }>
}

function BreadcrumbCustom({ routes }: BreadcrumbCustomProps) {
  const device = Device.useDevice()

  return device.isXS('bigger') ? (
    <div className={`container-breadcrumb`}>
      <Breadcrumb>
        {routes.map((route) => {
          return (
            <Breadcrumb.Item key={route.path}>
              <Link to={`/integrasocial/pesquisa/${route.path}`}>
                {route.title}
              </Link>
            </Breadcrumb.Item>
          )
        })}
      </Breadcrumb>
    </div>
  ) : (
    <></>
  )
}

export default BreadcrumbCustom
